module.exports = __webpack_public_path__ + "img/9-8.53421b9a.png";